<template>
    <div id="onfocusheight">
        <div class="import-export">
            <a href='#' @click="downloadResource(exportLink)" class="export-list-button">
                <span> {{$t('txt.export')}} </span>
                <i class="fas fa-download"></i>
            </a>
            <form id="import-providers" class="import-list-button">
                <b-form-file
                        name="file"
                        v-model="file"
                        ref="file-input"
                        :state="Boolean(file)"
                        placeholder="Incarca lista"
                        drop-placeholder="Drop file here..."
                        id='file'
                        multiple
                ></b-form-file>
                <button @click.prevent="importFile">
                    {{$t('txt.import')}}
                    <i class="fas fa-upload"></i>
                </button>
            </form>
        </div>
        <div class="page-title">
            <h4> {{$t('txt.listaFurnizori')}} </h4>
        </div>
        <div class="page-header-inner">
            <div class="table-header">
                <div class="search-box">
                    <div class="search-form">
                        <input
                                class="search-input"
                                type="search"
                                name="q"
                                :placeholder="$t('placeholder.cautaFurnizor')"
                                id="user-search"
                                v-model="search"
                                autocomplete="off">
                        <span class="focus-input"></span>
                        <span class="symbol-input" @click="applyQuery({ q: search })">
                                <i class="fas fa-search"></i>
                            </span>
                    </div>
                    <button type="button" class="template-button" @click="$router.push('/providers/create')" v-if="$can(['create provider'])">
                        <i class="fas fa-plus-circle"></i> {{$t('txt.adaugaFurnizor')}}
                    </button>
                </div>
            </div>
            <div class="filters-section">
                <div class="show-filters" v-on:click="showFilters = !showFilters">
                    <i class="fas fa-angle-double-right first-angle"></i>
                    <h4>
                        {{$t('txt.filtreazaDupa')}}:
                    </h4>
                    <i class="fas fa-angle-double-left second-angle"></i>
                </div>
                <div class="filters-wrapper-inner" :class="{fwi_active:showFilters}">
                    <div class="filters-wrapper-main">
                        <div class="filters-select">
                            <div class="filterSelection">
                                <label> {{$t('placeholder.judet')}}: </label>
                                <v-select v-model="filters.county" :options="this.counties" label="name"
                                          @input="getCitiesByCounty()" placeholder="Judet"></v-select>
                            </div>
                            <div class="filterSelection">
                                <label> {{$t('placeholder.oras')}}: </label>
                                <v-select v-model="filters.city" :options="this.cities" label="name" placeholder="Oras"></v-select>
                            </div>
                        </div>
                    </div>
                    <div class="filters-button">
                        <button type="button" class="reset-filters" @click="resetFilters()">
                            <i class="fas fa-undo"></i>
                            {{$t('txt.reseteazaFiltre')}}
                        </button>
                        <button type="button" @click="filterUsers()">
                            {{$t('txt.filtreaza')}}
                            <i class="fas fa-filter"></i>
                        </button>
                    </div>
                    <div class="close-filters" v-on:click="showFilters = !showFilters">
                        <i class="far fa-times-circle"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="utilities-result-wrapper" v-if="this.$route.query.q">
            <p class="search-result" v-if="this.$route.query.q">
                <i class="fas fa-poll-h"></i>
                {{$t('txt.cautareDupa')}} "{{this.searchBy}}"
            </p>
        </div>
        <div class="mobile-sorting">
            <div class="mobile-sort-by">
                <v-select :options="this.mobileSorting" v-model="sortMobile.sortMobileBy" @input="handleSortMobile(sortMobileBy, sortMobileType)" label="name" placeholder="Sorteaza dupa:">
                </v-select>
            </div>
            <div class="mobile-sort-method">
                <v-select :options="this.mobileSortingType" v-model="sortMobile.sortMobileType" @input="handleSortMobile(sortMobileBy, sortMobileType)" label="name" placeholder="Criteriu sortare:">
                </v-select>
            </div>
        </div>
        <table class="table app_table">
            <thead>
            <tr class="app_table_header">
                <th scope="col" @click="handleSort('first_name')"> {{$t('tableHeader.nume')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'first_name' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'first_name' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>
                <th scope="col" @click="handleSort('last_name')"> {{$t('tableHeader.prenume')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'last_name' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'last_name' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>
                <th scope="col" @click="handleSort('type')" class="mobilehidden_header"> {{$t('tableHeader.tipPersoana')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'type' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'type' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>
                <th scope="col" @click="handleSort('company_name')"> {{$t('tableHeader.companie')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'company_name' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'company_name' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>
                <th scope="col" @click="handleSort('phone')"> {{$t('tableHeader.telefon')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'phone' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'phone' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>
                <th scope="col" @click="handleSort('city')" class="mobilehidden_header"> {{$t('tableHeader.oras')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'city' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'city' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>
                <th scope="col" @click="handleSort('county')" class="mobilehidden_header"> {{$t('tableHeader.judet')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'county' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'county' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>
                <th scope="col"> {{$t('tableHeader.optiuni')}}</th>
            </tr>
            </thead>
            <tbody v-if="providers">
                <tr v-for="(provider, index) in providers" :key="index" @dblclick="$router.push({ name: 'viewprovider', params: { id: provider.id }})" @keyup.enter="$router.push({ name: 'viewprovider', params: { id: provider.id }})" tabindex="3">
                    <td :tableheadData="$t('tableHeader.nume')"> {{(provider.first_name) ? provider.first_name : '-'}}</td>
                    <td :tableheadData="$t('tableHeader.prenume')"> {{(provider.last_name) ? provider.last_name : '-'}}</td>
                    <td :tableheadData="$t('tableHeader.tipPersoana')" class="mobilehidden_header"> {{(parseInt(provider.type) === 2) ? 'PJ' : 'PF'}}</td>
                    <td :tableheadData="$t('tableHeader.companie')"> {{(provider.company_name) ? provider.company_name : '-'}}</td>
                    <td :tableheadData="$t('tableHeader.telefon')"> {{(provider.phone) ? provider.phone : '-'}}</td>
                    <td :tableheadData="$t('tableHeader.oras')" class="mobilehidden_header"> {{(provider.city) ? provider.city.name : '-'}}</td>
                    <td :tableheadData="$t('tableHeader.judet')" class="mobilehidden_header"> {{(provider.county) ? provider.county.name : '-'}}</td>
                    <td :tableheadData="$t('tableHeader.nume')" class="options-case">
                        <router-link :to="{ name: 'viewprovider', params: { id: provider.id }}" class="view-user" v-if="$can(['view provider'])"
                                     data-placement="top" data-toggle="tooltip" :title="$t('placeholder.vizualizeaza')">
                            <i class="fas fa-eye"></i>
                        </router-link>
                        <router-link :to="{ name: 'editprovider', params: { id: provider.id }}" class="edit-user" v-if="$can(['update provider'])"
                                     data-placement="top" data-toggle="tooltip" :title="$t('placeholder.editeaza')">
                            <i class="fas fa-pen"></i>
                        </router-link>
                        <a href="javascript:void(0)" class="delete-user" data-placement="top" data-toggle="tooltip" v-if="$can(['delete provider'])"
                           :title="$t('placeholder.sterge')" @click="removeUser(index, provider.id)">
                            <i class="fas fa-trash-alt"></i>
                        </a>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="8" v-if="this.$store.state.loading">{{$t('txt.loading')}}</td>
                    <td colspan="8" v-else>{{$t('errors.emptyResult')}}</td>
                </tr>
            </tbody>
            <tfoot v-if="providers">
            <tr class="app_table_header">
                <th scope="col">
                    {{$t('tableHeader.nume')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.prenume')}}
                </th>
                <th scope="col" class="mobilehidden_header">
                    {{$t('tableHeader.tipPersoana')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.companie')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.telefon')}}
                </th>
                <th scope="col" class="mobilehidden_header">
                    {{$t('tableHeader.oras')}}
                </th>
                <th scope="col" class="mobilehidden_header">
                    {{$t('tableHeader.judet')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.optiuni')}}
                </th>
            </tr>
            </tfoot>
        </table>
        <div class="col-lg-12 col-md-12" v-if="providers">
            <div class="pagination-wrapper">
                <div class="results-message">
                    <p>
                        <i class="fas fa-info-circle"></i>
                        {{$t('pagination.info', { from: this.meta.from, to: this.meta.to, total: this.meta.total })}}
                    </p>
                    <div class="filter-results-number">
                        <label> {{$t('txt.afiseaza')}}: </label>
                        <select v-model="filters.per_page" @change="applyQuery({ per_page: filters.per_page })">
                            <option value="25"> {{$t('txt.rezultatePePagina',{nr:25})}} </option>
                            <option value="50"> {{$t('txt.rezultatePePagina',{nr:50})}} </option>
                            <option value="100"> {{$t('txt.rezultatePePagina',{nr:100})}} </option>
                        </select>
                    </div>
                </div>
                <ul class="pagination-box">
                    <li class="pagination-point" v-if="this.meta.current_page !== 1">
                        <a href="javascript:void(0)" @click="applyQuery({ page: 1 })" class="Previous"><i
                                class="fas fa-angle-double-left pag-left"></i></a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== 1">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.current_page-1 })"
                           class="Previous"><i class="fas fa-angle-left pag-left"></i></a>
                    </li>
                    <li class="pp-dot" v-for="page in pagination"
                        :class="{'pp-dot-active': meta.current_page === page }" :key="page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: page })">{{page}}</a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== this.meta.last_page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.current_page+1 })"><i
                                class="fas fa-angle-right pag-right"></i> </a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== this.meta.last_page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.last_page })"> <i
                                class="fas fa-angle-double-right pag-right"></i></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import ProvidersService from '../../api-services/providers.service.js'
import CountiesService from '../../api-services/counties.service.js'
export default {
  name: 'providers',
  data () {
    return {
      exportLink: process.env.VUE_APP_API_ENDPOINT + '/export/providers',
      sortMobile: {
        sortMobileBy: null,
        sortMobileType: null
      },
      mobileSorting: [
        { key: 'first_name', name: 'Nume' },
        { key: 'last_name', name: 'Prenume' },
        { key: 'type', name: 'Tip Persoana' },
        { key: 'company_name', name: 'Companie' },
        { key: 'phone', name: 'Telefon' },
        { key: 'city', name: 'Oras' },
        { key: 'county', name: 'Judet' }
      ],
      mobileSortingType: [
        { key: 'ASC', name: 'Crescator' },
        { key: 'DESC', name: 'Descrescator' }
      ],
      providers: null,
      counties: [],
      cities: [],
      filters: {
        county: null,
        city: null,
        per_page: 25
      },
      search: '',
      searchBy: this.$route.query.q || null,
      showFilters: (this.$route.query.f_county && this.$route.query.f_county > 0) || (this.$route.query.f_city && this.$route.query.f_city > 0),
      meta: {},
      file: null
    }
  },
  watch: {
    'filters.county': function (newVal, oldVal) {
      if (newVal == null) {
        this.filters.city = null
      }
    },
    search: async function (value) {
      let response = await ProvidersService.getOfflineData({ q: value, per_page: this.filters.per_page })
      this.providers = response.data.data
      this.meta = response.data.meta
    },
    '$route.query' () {
      this.getProviders()
    }
  },
  mounted () {
    let cauta = document.getElementById('user-search')
    let timeout = null
    let vm = this
    cauta.addEventListener('input', function (e) {
      if (timeout !== null) {
        clearTimeout(timeout)
      }
      timeout = setTimeout(function () {
        vm.getProviders({ q: vm.search, per_page: vm.filters.per_page })
      }, 1000)
    })
    this.focusSearch()
  },
  computed: {
    sortMobileBy () {
      return (this.sortMobile.sortMobileBy) ? this.sortMobile.sortMobileBy.key : null
    },
    sortMobileType () {
      return (this.sortMobile.sortMobileType) ? this.sortMobile.sortMobileType.key : null
    },
    // return first page from pagination html
    start_page () {
      if (this.meta.last_page > 5 && this.meta.current_page > 2) {
        return this.meta.current_page - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page () {
      if (this.meta.last_page > 5 && this.meta.current_page + 2 < this.meta.last_page) {
        return this.meta.current_page + 2
      } else {
        return this.meta.last_page
      }
    },
    // return only 5 pages for pagination
    pagination () {
      let pages = []
      for (let i = this.start_page; i <= this.stop_page; i++) {
        pages.push(i)
      }
      return pages
    }
  },
  methods: {
    getProviders (params) {
      ProvidersService.getAll(params)
        .then((response) => {
          if (response.data.data.length > 0) {
            this.providers = response.data.data
          } else {
            this.providers = null
          }
          this.meta = response.data.meta
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          let message = error.response.data.error
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: message,
            'animation-type': 'css'
          })
          this.$store.dispatch('hideLoading')
        })
    },
    getCounties () {
      CountiesService.getAll({ per_page: -1 })
        .then((response) => {
          this.counties = response.data.data
          if (this.$route.query.f_county) {
            let countyId = parseInt(this.$route.query.f_county)
            this.filters.county = this.counties.find(county => county.id === countyId)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getCitiesByCounty (countyId) {
      this.cities = []
      if (!countyId && (this.filters.county && this.filters.county.id)) {
        countyId = this.filters.county.id
      }
      if (countyId && countyId > 0) {
        let countyId = (this.filters.county && this.filters.county.id) ? this.filters.county.id : this.$route.query.f_county
        CountiesService.get(countyId)
          .then((response) => {
            this.cities = response.data.data.cities
            if (this.$route.query.f_city) {
              this.filters.city = this.cities.find(city => city.id === parseInt(this.$route.query.f_city))
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    // Send and Apply query params in url
    applyQuery (params) {
      let resetPage = { page: '1' }
      let currentQuery = this.$route.query
      if (params.q) {
        this.searchBy = this.search
      }
      // params = _.pickBy(params)
      // merge 3 objects
      let query = { ...currentQuery, ...resetPage, ...params }
      this.$router.push({ name: 'providers', query: query })
    },
    // Apply sort params on column
    handleSort (column) {
      if (this.$route.query.sort_by === column && this.$route.query.sort_type === 'ASC') {
        this.applyQuery({ sort_by: column, sort_type: 'DESC' })
      } else {
        this.applyQuery({ sort_by: column, sort_type: 'ASC' })
      }
    },
    handleSortMobile (column, type) {
      if (column) {
        if (!this.sortMobile.sortMobileBy) {
          let found = this.mobileSorting.find(function (element) {
            return element.key === column
          })
          this.sortMobile.sortMobileBy = found
        }
        if (type) {
          if (!this.sortMobile.sortMobileType) {
            let found = this.mobileSortingType.find(function (element) {
              return element.key === type
            })
            this.sortMobile.sortMobileType = found
          }
        } else {
          if (!this.sortMobile.sortMobileType) {
            let found = this.mobileSortingType.find(function (element) {
              return element.key === 'ASC'
            })
            this.sortMobile.sortMobileType = found
          }
          type = this.sortMobile.sortMobileType.key
        }
        this.applyQuery({ sort_by: column, sort_type: type })
      } else {
        this.applyQuery({ sort_by: null, sort_type: null })
      }
    },
    filterUsers () {
      if (this.filters.county && this.filters.city) {
        this.applyQuery({ f_county: this.filters.county.id, f_city: this.filters.city.id })
      } else if (this.filters.county) {
        // let newRouteQuery = _.omit(this.$route.query, 'f_city')
        // this.$router.replace( { query: newRouteQuery } )
        this.applyQuery({ f_county: this.filters.county.id, f_city: 0 })
      } else {
        this.applyQuery({ f_county: 0, f_city: 0 })
      }
      this.showFilters = false
    },
    resetFilters () {
      this.filters.city = null
      this.filters.county = null
      this.applyQuery({ f_county: 0, f_city: 0, page: 1 })
      this.showFilters = false
    },
    removeUser (index, id) {
      this.$swal.fire({
        title: this.$t('txt.suntetiSigur'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('txt.stergeFurnizor'),
        cancelButtonText: this.$t('txt.anuleaza')
      }).then((result) => {
        if (result.value) {
          ProvidersService.delete(id)
            .then((response) => {
              this.$delete(this.providers, index)
            })
            .catch((error) => {
              let message = error.response.data.error
              this.$notify({
                group: 'error',
                type: 'error',
                title: 'Error',
                text: message,
                'animation-type': 'css'
              })
            })
        }
      })
    },
    importFile () {
      let formData = new FormData(document.getElementById('import-providers'))
      ProvidersService.importProviders(formData)
        .then((response) => {
          if (response.data.data.total === response.data.data.count) {
            this.$notify({
              group: 'succes',
              type: 'success',
              title: this.$t('txt.succes'),
              text: this.$t('success.importSucces'),
              'animation-type': 'css'
            })
          } else {
            this.$notify({
              group: 'warning',
              type: 'warning',
              title: this.$t('txt.succes'),
              text: this.$t('success.importPartial', { nr: response.data.data.inserted, total: response.data.data.total, type: 'furnizori' }),
              'animation-type': 'css'
            })
          }
          this.getProviders()
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
  created () {
    let query = this.$route.query
    if (query.q) this.search = query.q
    this.getCounties()
    if (query.sort_by && query.sort_type) {
      this.handleSortMobile(query.sort_by, query.sort_type)
    } else if (query.sort_by) {
      this.handleSortMobile(query.sort_by)
    }
    if (query.f_county) this.getCitiesByCounty(query.f_county)
    this.getProviders()
  }
}
</script>
